export default "__VITE_ASSET__DK7LDQM5__"